import { createSlice } from "@reduxjs/toolkit";

export const TokenRefreshReducer = createSlice({
  name: "tokenRefresh",
  initialState: {
    isRefreshing: false,
  },
  reducers: {
    tokenRefreshStarted: (state) => {
      state.isRefreshing = true;
    },
    tokenRefreshFinished: (state) => {
      state.isRefreshing = false;
    },
  },
});

export const { tokenRefreshStarted, tokenRefreshFinished } = TokenRefreshReducer.actions;

export default TokenRefreshReducer.reducer;